<app-data-set #dataSet [dataSource]="dataSource" [selectedDisplayFormat]="formatSelectedUserName" [rowId]="rowId">
	<app-data-set-toolbar>
		<div *appSearchActionGroup style="flex: 1">
			<app-data-set-search
				defaultFilterName="name"
				[defaultFilterLabel]="fieldLabels.name"
				[placeholder]="fieldLabels.defaultPlaceholder"
			>
				<div class="filter-grid" [style.--columns]="3">
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ fieldLabels.name }}</mat-label>
							<input
								matInput
								data-automation-id="name-input"
								[ngModel]="dataSet.filter('name')"
								(ngModelChange)="dataSet.filter('name', fieldLabels.name, $event)"
							/>
						</mat-form-field>
					</div>
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ fieldLabels.email }}</mat-label>
							<input
								matInput
								data-automation-id="email-input"
								[ngModel]="dataSet.filter('email')"
								(ngModelChange)="dataSet.filter('email', fieldLabels.email, $event)"
							/>
						</mat-form-field>
					</div>
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ fieldLabels.phoneNumber }}</mat-label>
							<input
								matInput
								data-automation-id="phone-number-input"
								[ngModel]="dataSet.filter('phoneNumber')"
								(ngModelChange)="dataSet.filter('phoneNumber', fieldLabels.phoneNumber, $event)"
							/>
						</mat-form-field>
					</div>
				</div>

				<div class="filter-grid" [style.--columns]="2">
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ fieldLabels.status }}</mat-label>
							<mat-select
								[ngModel]="dataSet.filter('active')"
								data-automation-id="status-picker"
								(ngModelChange)="dataSet.filter('active', fieldLabels.status, $event, activeFilterOptions)"
							>
								@for (option of activeFilterOptions; track option) {
									<mat-option [value]="option.value" [attr.data-automation-id]="'status-' + option.value">{{
										option.label
									}}</mat-option>
								}
							</mat-select>
						</mat-form-field>
					</div>
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ fieldLabels.roleName }}</mat-label>
							<input
								matInput
								data-automation-id="role-name-input"
								[ngModel]="dataSet.filter('roleName')"
								(ngModelChange)="dataSet.filter('roleName', fieldLabels.roleName, $event)"
							/>
						</mat-form-field>
					</div>
				</div>
			</app-data-set-search>
		</div>

		@if (canAddUser) {
			<div *appActionGroup>
				<app-data-set-action-button
					icon="add"
					label="Add"
					i18n-label="@@companyUser-addLabel"
					(click)="navigateToAddUser()"
					data-automation-id="add-user-button"
				>
				</app-data-set-action-button>
			</div>
		}
	</app-data-set-toolbar>

	<app-data-set-content>
		<app-data-set-table-view>
			@if (loadingService.isLoading(getCompanyUsersByCompanyIdLoadingKey) || !finishedLoadingInitData) {
				<app-data-set-loading-row />
			}
			<table
				mat-table
				[dataSource]="dataSource"
				matSort
				[hidden]="loadingService.isLoading(getCompanyUsersByCompanyIdLoadingKey) || !finishedLoadingInitData"
			>
				<tr class="mat-row" *matNoDataRow>
					<td class="mat-cell" [colSpan]="displayedColumns.length" i18n="@@dataSetTable-noRecordsFound">
						No records found.
					</td>
				</tr>

				<ng-container matColumnDef="name">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@companyUser-name2">Name</th>
					<td mat-cell *matCellDef="let row">{{ row.user.firstName }} {{ row.lastName }}</td>
				</ng-container>

				<ng-container matColumnDef="email">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@companyUser-email2">Email</th>
					<td mat-cell *matCellDef="let row">{{ row.user.email }}</td>
				</ng-container>

				<ng-container matColumnDef="phoneNumber">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@companyUser-phone2">Phone Number</th>
					<td mat-cell *matCellDef="let row">{{ row.user.phoneNumber?.rawPhoneNumber }}</td>
				</ng-container>

				<ng-container matColumnDef="active">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@companyUser-status2">Status</th>
					<td mat-cell *matCellDef="let row">
						@if (row.user.verified === true && row.user.active === true) {
							<span i18n="@@companyUser-active">Active</span>
						}
						@if (row.user.active === false) {
							<span i18n="@@companyUser-inactive" class="font-color-red">Inactive</span>
						}
						@if (row.user.verified === false && row.user.active !== false) {
							<span i18n="@@companyUser-pending">Pending</span>
						}
					</td>
				</ng-container>

				<ng-container matColumnDef="roleName">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@companyUser-role2">Role</th>
					<td mat-cell *matCellDef="let row">{{ row.roleName }}</td>
				</ng-container>

				<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
				<tr
					mat-row
					*matRowDef="let row; columns: displayedColumns"
					(appDataSetRowClick)="onRowClick(row)"
					[attr.data-automation-id]="'company-user-' + row.id + '-row'"
				></tr>
			</table>
		</app-data-set-table-view>
	</app-data-set-content>
</app-data-set>
